module.exports = __webpack_public_path__ + "img/28_34.fdcd4b31.png";